import { PagedTable } from 'bold-ui'
import { TableBox } from 'components/table/TableBox'
import { usePagedTableProps } from 'components/table/usePagedTableProps'
import { useConfiguracoesAtencaoDomQuery } from 'graphql/hooks.generated'
import { ConfiguracoesAtencaoDomQuery, ConfiguracoesAtendimentosDomInput } from 'graphql/types.generated'
import { useState } from 'react'

import ConfiguracoesADButtonExcluir from './ConfiguracoesADButtonExcluir'
import ConfiguracoesADPodeAtenderForm from './ConfiguracoesADPodeAtenderForm'

export type ConfiguracaoAdPodeAtenderItemType = ConfiguracoesAtencaoDomQuery['configuracoesAtencaoDom']['emadsAtendemEmads']['content'][0]

export default function ConfiguracoesADPodeAtenderTable() {
  const [pageParams, setPageParams] = useState<ConfiguracoesAtendimentosDomInput>()

  const { data, refetch, loading } = useConfiguracoesAtencaoDomQuery({
    variables: { input: pageParams },
  })

  const emadsAtendemEmads = data?.configuracoesAtencaoDom?.emadsAtendemEmads

  const tableProps = usePagedTableProps({
    loading,
    result: emadsAtendemEmads,
    onChange: setPageParams,
  })

  const renderEmadPai = (row: ConfiguracaoAdPodeAtenderItemType) =>
    `${row.identificadorNacionalEquipePai.nome} - ${row.identificadorNacionalEquipePai.ine}`

  const renderEmadFilho = (row: ConfiguracaoAdPodeAtenderItemType) =>
    `${row.identificadorNacionalEquipeFilho.nome} - ${row.identificadorNacionalEquipeFilho.ine}`

  const renderButtons = (row: ConfiguracaoAdPodeAtenderItemType) => (
    <ConfiguracoesADButtonExcluir configItem={row} reload={refetch} />
  )

  return (
    <TableBox header={<ConfiguracoesADPodeAtenderForm reload={refetch} />}>
      <PagedTable<ConfiguracaoAdPodeAtenderItemType>
        {...tableProps}
        columns={[
          {
            name: 'emap',
            header: 'EMAD',
            render: renderEmadPai,
          },
          {
            name: 'emad',
            header: 'EMAD',
            render: renderEmadFilho,
          },
          {
            name: 'buttons',
            render: renderButtons,
            style: { textAlign: 'right', whiteSpace: 'nowrap' },
          },
        ]}
      />
    </TableBox>
  )
}
